<template lang="pug">
	.create-new-order(v-if="showed")
		.card
			.card-header Create New Order
			.card-body
				.order-property
					.order-property-name Order Name
					.order-property-value
						input.form-control(v-model="orderName" ref="orderNameInput")
				.order-property
					.order-property-name Impression Price (CPM)
					.order-property-value
						input.form-control(type="number", step=0.01 v-model="orderImpressionPrice" ref="orderImpressionPriceInput")
				.order-property
					.order-property-name Active
					.order-property-value
						input.form-control.checkbox(type="checkbox" v-model="orderActive" ref="orderActiveInput")
				.error-message {{errorMessage}}
			.card-footer
				button.btn.btn-cancel(@click="hide") Cancel
				button.btn.btn-confirm(type="submit" @click="createNewOrder") Create Order

</template>

<script>

	import Screen from "@/mixins/screen";
	import {Server} from "@/services/Server";

	export default {
		name: 'CreateNewOrder',
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {
				'New Order Created': function (error = false) {
					if (!error) {
						this.hide();
						return;
					}
					this.errorMessage = error;
				}
			}
		},
		data() {

			this.Server = Server;

			return {
				orderName: '',
				orderActive: true,
				orderImpressionPrice: '',
				errorMessage: ''
			}
		},
		methods: {
			collectData() {
				this.orderName = '';
				this.orderActive = true;
				this.orderImpressionPrice = '';
				this.errorMessage = '';
			},

			createNewOrder() {
				if (!this.orderName) {
					this.errorMessage = 'Please provide valid order name';
					return;
				}
				if (!this.orderImpressionPrice) {
					this.errorMessage = 'Please provide valid order impression price';
					return;
				}

				Server.sendToSocket({
					CreateNewOrder: {
						name: this.orderName,
						active: this.orderActive,
						impressionPrice: this.orderImpressionPrice
					}
				});
			}
		}
	}

</script>

<style lang="sass">

	.create-new-order
		position: absolute
		z-index: 2000
		top: 0
		left: 0
		bottom: 0
		right: 0
		display: flex
		justify-content: center
		align-items: center

		>.card
			width: 400px

			>.card-footer
				display: flex
				flex-direction: row
				justify-content: space-between

			>.card-body
				display: flex
				flex-direction: column
				gap: 0.5em

				>.error-message
					font-size: 95%
					color: red
				>.order-property
					display: flex
					flex-direction: row
					align-items: center
					gap: 15px

					>.order-property-name
						width: 160px

					>.order-property-value
						flex: 1

						>input
							height: 35px
						>input.checkbox
							width: 35px
							height: 35px




</style>
